import backlinkApi from './backlinkNewApi';

const exportApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    exportBacklinkTable: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/export',
        method: 'POST',
        body
      })
    })
  }),
  overrideExisting: false
});

export const { useExportBacklinkTableMutation } = exportApi;
export default exportApi;
